module.exports = __webpack_public_path__ + "img/com.83e3c799.png";